import { render, staticRenderFns } from "./ProjectEmployees.vue?vue&type=template&id=53591a7f&scoped=true&"
import script from "./ProjectEmployees.vue?vue&type=script&lang=js&"
export * from "./ProjectEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEmployees.vue?vue&type=style&index=0&id=53591a7f&lang=scss&scoped=true&"
import style1 from "./ProjectEmployees.vue?vue&type=style&index=1&id=53591a7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53591a7f",
  null
  
)

export default component.exports